/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsDebitOrderViewModel } from './PaymentDetailsDebitOrderViewModel';
import {
    PaymentDetailsDebitOrderViewModelFromJSON,
    PaymentDetailsDebitOrderViewModelFromJSONTyped,
    PaymentDetailsDebitOrderViewModelToJSON,
} from './PaymentDetailsDebitOrderViewModel';
import type { PaymentDetailsEFTViewModel } from './PaymentDetailsEFTViewModel';
import {
    PaymentDetailsEFTViewModelFromJSON,
    PaymentDetailsEFTViewModelFromJSONTyped,
    PaymentDetailsEFTViewModelToJSON,
} from './PaymentDetailsEFTViewModel';
import type { PaymentDetailsInternalTransferViewModel } from './PaymentDetailsInternalTransferViewModel';
import {
    PaymentDetailsInternalTransferViewModelFromJSON,
    PaymentDetailsInternalTransferViewModelFromJSONTyped,
    PaymentDetailsInternalTransferViewModelToJSON,
} from './PaymentDetailsInternalTransferViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsLumpSumViewModel
 */
export interface PaymentDetailsLumpSumViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsLumpSumViewModel
     */
    paymentCategoryId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsLumpSumViewModel
     */
    totalAmount: number;
    /**
     * 
     * @type {PaymentDetailsEFTViewModel}
     * @memberof PaymentDetailsLumpSumViewModel
     */
    eft?: PaymentDetailsEFTViewModel;
    /**
     * 
     * @type {PaymentDetailsDebitOrderViewModel}
     * @memberof PaymentDetailsLumpSumViewModel
     */
    onceOffDebitOrder?: PaymentDetailsDebitOrderViewModel;
    /**
     * 
     * @type {PaymentDetailsInternalTransferViewModel}
     * @memberof PaymentDetailsLumpSumViewModel
     */
    internalCashTransfer?: PaymentDetailsInternalTransferViewModel;
}

/**
 * Check if a given object implements the PaymentDetailsLumpSumViewModel interface.
 */
export function instanceOfPaymentDetailsLumpSumViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentCategoryId" in value;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

export function PaymentDetailsLumpSumViewModelFromJSON(json: any): PaymentDetailsLumpSumViewModel {
    return PaymentDetailsLumpSumViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsLumpSumViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsLumpSumViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentCategoryId': json['PaymentCategoryId'],
        'totalAmount': json['TotalAmount'],
        'eft': !exists(json, 'Eft') ? undefined : PaymentDetailsEFTViewModelFromJSON(json['Eft']),
        'onceOffDebitOrder': !exists(json, 'OnceOffDebitOrder') ? undefined : PaymentDetailsDebitOrderViewModelFromJSON(json['OnceOffDebitOrder']),
        'internalCashTransfer': !exists(json, 'InternalCashTransfer') ? undefined : PaymentDetailsInternalTransferViewModelFromJSON(json['InternalCashTransfer']),
    };
}

export function PaymentDetailsLumpSumViewModelToJSON(value?: PaymentDetailsLumpSumViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PaymentCategoryId': value.paymentCategoryId,
        'TotalAmount': value.totalAmount,
        'Eft': PaymentDetailsEFTViewModelToJSON(value.eft),
        'OnceOffDebitOrder': PaymentDetailsDebitOrderViewModelToJSON(value.onceOffDebitOrder),
        'InternalCashTransfer': PaymentDetailsInternalTransferViewModelToJSON(value.internalCashTransfer),
    };
}

